import styled from 'styled-components';
import { ERROR_COLOR, FONT_FAMILY_MAIN } from '../../../theme';

export const ErrorMessageContainer = styled.div`
  font-family: ${FONT_FAMILY_MAIN};
  color: ${ERROR_COLOR};
  font-size: 12px;
  line-height: 1.17;
  margin-top: 3px;
`;
